module.exports = __webpack_public_path__ + "static/media/genisis5.9f59a9d3.jpg";